document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.about-husen');
  if (!section) return;

  const bodies = Array.from(section.querySelectorAll('[data-animate="body"]'));
  if (!bodies.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    bodies.forEach((p) => gsap.set(p, { '--mark-a': 1 }));
    return;
  }

  bodies.forEach((p) => {
    const isLead = p.closest('.husen-block--1');
    const delayMs = Number(p.dataset.delay || 0);
    const delaySec = delayMs > 20 ? delayMs / 1000 : delayMs;
    gsap.set(p, { '--mark-a': isLead ? 1 : 0 });
    if (typeof window.animateBodyText !== 'function') return;
    window.animateBodyText(p, {
      useScrollTrigger: true,
      autoPlay: true,
      delay: delaySec,
      onReady: (elem) => {
        const lineTl = elem._bodyLineTimeline;
        if (!lineTl) return;
        if (isLead) {
          lineTl.set(elem, { '--mark-a': 1 }, 0);
          return;
        }
        lineTl.fromTo(
          elem,
          { '--mark-a': 0 },
          { '--mark-a': 1, duration: 0.4, ease: 'none' },
          delaySec
        );
      },
    });
  });

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => {
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    });
  }
});
